import React, { useState } from "react";
import { Form } from "react-bootstrap";

const ModalInputSelect = (props) => {
  const [selval, setselval] = useState("");
  const thisChange = (e) => {
    let vl = e.target.value;
    if (vl !== "") {
      let Val = vl === "Allow" ? 1 : 0;
      props.Action(props.Index, Val);
      setselval(vl);
    }
  };
  return (
    <Form.Group controlId="Select">
      <Form.Control
        as="select"
        value={selval}
        onChange={(e) => thisChange(e)}
        name={props.myName}
        style={{ boxShadow: "5px 5px #b1b1b1" }}
      >
        {props.myOptions.map((opt, index) => (
          <option value={opt == "Select" ? "" : opt} key={index}>
            {opt}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  );
};

export default ModalInputSelect;
